// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Switch-module__main--i4xMq {
    --switch-size: 18px;
    --container-height: 24px;
    --container-width: 48px;
    --container-color: var(--color-primary);
    --container-border-color: var(--color-primary);
    --switch-color: var(--color-general-white);
    --horizontal-padding: 2px;

    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: var(--container-width);
    height: var(--container-height);
    border-radius: var(--container-height);
    background-color: var(--container-color);
    border: 1px solid var(--container-border-color);
    box-sizing: border-box;
    padding: 0 var(--horizontal-padding);
    cursor: pointer;
}

.Switch-module__main--i4xMq input[type="checkbox"] {
    display: none;
}

.Switch-module__main--i4xMq.Switch-module__disabled--M1BgV {
    --container-color: var(--color-primary-light);
    --container-border-color: var(--color-primary-light);
    --switch-color: var(--color-general-white);
    cursor: not-allowed;
}

.Switch-module__main--i4xMq:has(input[type="checkbox"]:checked) {
    justify-content: flex-end;
    --switch-color: var(--color-primary);
    --container-border-color: var(--color-primary);
    --container-color: var(--color-general-white);
}

.Switch-module__main--i4xMq.Switch-module__disabled--M1BgV:has(input[type="checkbox"]:checked) {
    --container-color: var(--color-general-white);
    --container-border-color: var(--color-primary-light);
    --switch-color: var(--color-primary-light);
}

.Switch-module__main--i4xMq.Switch-module__small--mnoQI {
    --switch-size: 14px;
    --container-height: 18px;
    --container-width: 32px;
    --horizontal-padding: 1px;
}

.Switch-module__switch--hCthG {
    display: block;
    width: var(--switch-size);
    height: var(--switch-size);
    border-radius: var(--switch-size);
    background-color: var(--switch-color);
}
`, "",{"version":3,"sources":["webpack://./src/dom/components/Switch/Switch.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,wBAAwB;IACxB,uBAAuB;IACvB,uCAAuC;IACvC,8CAA8C;IAC9C,0CAA0C;IAC1C,yBAAyB;;IAEzB,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,6BAA6B;IAC7B,+BAA+B;IAC/B,sCAAsC;IACtC,wCAAwC;IACxC,+CAA+C;IAC/C,sBAAsB;IACtB,oCAAoC;IACpC,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,6CAA6C;IAC7C,oDAAoD;IACpD,0CAA0C;IAC1C,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,oCAAoC;IACpC,8CAA8C;IAC9C,6CAA6C;AACjD;;AAEA;IACI,6CAA6C;IAC7C,oDAAoD;IACpD,0CAA0C;AAC9C;;AAEA;IACI,mBAAmB;IACnB,wBAAwB;IACxB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,0BAA0B;IAC1B,iCAAiC;IACjC,qCAAqC;AACzC","sourcesContent":[".main {\n    --switch-size: 18px;\n    --container-height: 24px;\n    --container-width: 48px;\n    --container-color: var(--color-primary);\n    --container-border-color: var(--color-primary);\n    --switch-color: var(--color-general-white);\n    --horizontal-padding: 2px;\n\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    width: var(--container-width);\n    height: var(--container-height);\n    border-radius: var(--container-height);\n    background-color: var(--container-color);\n    border: 1px solid var(--container-border-color);\n    box-sizing: border-box;\n    padding: 0 var(--horizontal-padding);\n    cursor: pointer;\n}\n\n.main input[type=\"checkbox\"] {\n    display: none;\n}\n\n.main.disabled {\n    --container-color: var(--color-primary-light);\n    --container-border-color: var(--color-primary-light);\n    --switch-color: var(--color-general-white);\n    cursor: not-allowed;\n}\n\n.main:has(input[type=\"checkbox\"]:checked) {\n    justify-content: flex-end;\n    --switch-color: var(--color-primary);\n    --container-border-color: var(--color-primary);\n    --container-color: var(--color-general-white);\n}\n\n.main.disabled:has(input[type=\"checkbox\"]:checked) {\n    --container-color: var(--color-general-white);\n    --container-border-color: var(--color-primary-light);\n    --switch-color: var(--color-primary-light);\n}\n\n.main.small {\n    --switch-size: 14px;\n    --container-height: 18px;\n    --container-width: 32px;\n    --horizontal-padding: 1px;\n}\n\n.switch {\n    display: block;\n    width: var(--switch-size);\n    height: var(--switch-size);\n    border-radius: var(--switch-size);\n    background-color: var(--switch-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `Switch-module__main--i4xMq`,
	"disabled": `Switch-module__disabled--M1BgV`,
	"small": `Switch-module__small--mnoQI`,
	"switch": `Switch-module__switch--hCthG`
};
export default ___CSS_LOADER_EXPORT___;
